import { apiFiles } from "@/api/file.api";
import useErrorHandle from "@/hooks/use-error-handle.hook";
import { ApiFilePathTypes } from "@/types/file.types";
import { Avatar, DropdownMenu, DropdownMenuItem, FontAwesomeIcon, Stack } from "@skailer-com/uikit";
import { ChangeEvent, useRef, useState } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { HireFieldValues } from "../hire-form";

export function HireAvatarChoice({
  form,
  preview,
  onUploadingChange,
}: {
  form: UseFormReturn<HireFieldValues>;
  preview: boolean;
  onUploadingChange: (uploading: boolean) => void;
}) {
  const { t } = useTranslation();
  const { handleErrors } = useErrorHandle();
  const input = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);
  const url = useWatch({ control: form.control, name: "avatar_url" }) as string | undefined;
  const firstName = useWatch({ control: form.control, name: "first_name" });
  const lastName = useWatch({ control: form.control, name: "last_name" });
  const acronym = firstName && lastName ? `${firstName} ${lastName}` : undefined;
  const choose = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (preview) {
      form.setValue("avatar_url", URL.createObjectURL(file));
      return;
    }
    const data = new FormData();
    data.append("file", file);
    data.append("path", ApiFilePathTypes.employee);
    data.append("is_public", "true");
    data.append("save_original_name", "true");
    setUploading(true);
    onUploadingChange(true);
    try {
      const result = await apiFiles.add(data);
      if (result.data) {
        form.setValue("avatar_file_uuid", result.data.uuid);
        form.setValue("avatar_url", result.data.url_permanent);
      } else handleErrors(result.error);
    } finally {
      setUploading(false);
      onUploadingChange(false);
    }
  };
  return (
    <Stack items="start">
      <input ref={input} type="file" accept="image/*" hidden onChange={choose} />
      <DropdownMenu
        trigger={
          <Avatar
            url={url}
            className="border-none bg-light shadow-lg cursor-pointer rounded-sm"
            size="2xl"
            acronym={acronym}
            icon={!acronym ? <FontAwesomeIcon icon="fa-light fa-camera" /> : undefined}
          />
        }
      >
        <DropdownMenuItem
          leftIcon={<FontAwesomeIcon icon="fa-light fa-image" />}
          onClick={() => {
            if (!uploading) input.current?.click();
          }}
          title={t("common:upload_photo")}
        />
      </DropdownMenu>
    </Stack>
  );
}
